import type { UserRoleName } from "@/types/role";

export const UserRoleToIdMap = new Map<UserRoleName, number>();
UserRoleToIdMap.set("client", 2);
UserRoleToIdMap.set("landlord", 3);
UserRoleToIdMap.set("guest", 4);

export const DEFAULT_REGISTERABLE_ROLES = [
  {
    id: 2,
    roleName: "client",
    notes: "Users who find and look for accommodations.",
  },
  {
    id: 3,
    roleName: "landlord",
    notes: "Users post properties and accommodations.",
  },
];
